<template>
  <ApplicationLayout
    :user="user"
    :options="options"
    :version="version"
    :links="links"
    :showActionItems="true"
  >
    <!-- Set System bar content if enabled-->
    <template #systembar> </template>

    <!-- Set Appbar title-->
    <template #title>
      <v-icon class="mr-2">mdi-scale-balance</v-icon>
      <v-toolbar-title class="font-weight-bold d-flex">
        General Ledger
      </v-toolbar-title>
    </template>

    <!-- Use to add addition items to Appbar -->
    <template #toolbar>
      <ReportIssueButton  class="mr-6"/>
    </template>

    <!-- Use change Navbar header content-->
    <template #navheader> </template>

    <!-- Use display content-->
    <template #content>
      <router-view />
    </template>
  </ApplicationLayout>
</template>

<script>
import ApplicationLayout from '@/modules/shared/components/core/layouts/ApplicationLayout.vue';
import PageMixin from '@/mixins/page.mixin';
import generalLedgerLinks from '@/modules/general-ledger/routes/links';
import { mapGetters } from 'vuex';
import ReportIssueButton from '@/modules/shared/components/core/ReportIssueButton.vue';

const layoutOptions = {
  showSystemBar: false,
  showSearchBar: false,
  showUserOptions: true,
  showMenuToggle: true,

  appBarColor: '#fafbfc',
  miniDrawerColor: '',
  miniDrawerIconsColor: 'white',
  leftDrawerColor: 'white',
  leftDrawerIconsColor: ''
};

export default {
  components: { ApplicationLayout, ReportIssueButton },
  mixins: [PageMixin],
  data: () => ({
    options: layoutOptions,
    links: generalLedgerLinks
  }),
  computed: {
    ...mapGetters('appModulesModule', ['activeModuleNames']),
  }
};
</script>
